<template>
  <div id="app">
	<router-view/>
  </div>
</template>

<script>
export default {
	name: 'App',
	created() {
		//+-------------获取临时token-------------
		if(!localStorage.getItem('token')){
			this.customerLogin();
		};
	},
	methods:{
		//+----------------------游客登录------------------
		customerLogin(){
			this.apiServer.login.customerLogin()
			.then(res => {
				if(res.data.code == 200 && res.data.data.token)
				{
					//保存用户token
					localStorage.setItem('token',res.data.data.token);
				}
			})
		},
	}
}
</script>

<style>
	#app {
	  font-family: 'Avenir', Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	  color: #2c3e50;
	}
  
	.page{
		background-color:#F2F2F2;
		height:100%;
		width:100%;
	}
  
	/* 容器主体 */
	.main{
		background-color: #f2f2f2;
		list-style: none;
		padding: 0;
		margin: 0 auto;
		min-width: 1314px;
	}
	/* 大屏幕 ：大于等于1200px*/
	@media (min-width: 1200px) {
		
	}

	/*默认*/
	@media (min-width: 980px) {
		
	}

	/* 平板电脑和小屏电脑之间的分辨率 */
	@media (min-width: 768px) and (max-width: 979px) {

	}

	/* 横向放置的手机和竖向放置的平板之间的分辨率 */
	@media (max-width: 767px) {

	}

	/* 横向放置的手机及分辨率更小的设备 */
	@media (max-width: 480px) {
	}
</style>



// WEBPACK FOOTER //
// src/App.vue